import * as React from 'react';
import Badge, { BadgeProps } from 'src/components/Badge';
import { useTooltip } from 'src/components/CustomTooltip';
import { StatusCode } from '../../types';

type StatusBadgeProps = {
  status: StatusCode;
  className?: string;
};

const statusColor: Record<StatusCode, BadgeProps['color']> = {
  G: 'success',
  K: 'black',
  S: 'blue'
};

const statusTooltips: Record<StatusCode, string> = {
  G: 'Godkendt',
  K: 'Aflyst',
  S: 'Afsluttet'
};

const StatusBadge = ({ status, className }: StatusBadgeProps) => (
  <Badge
    color={statusColor[status]}
    round={true}
    size="mini"
    className={className}
    {...useTooltip(statusTooltips[status])}
  >
    {status}
  </Badge>
);

export default StatusBadge;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Reports/components/ResultTable/StatusBadge.tsx